import { IFileDTOOut, IFileElement, IFolderDTOOut } from '../../interfaces/file-element.interface';

export class GetRootFolder {
    public static readonly type = '[Root folder] get';
}

export class GetFolderById {
    public static readonly type = '[Folder] get by id';
    constructor(public parentFolder: IFileElement) {}
}

export class CreateFolder {
    public static readonly type = '[Folder] create';
    constructor(public parentFolder: IFileElement, public newFolder: IFolderDTOOut) {}
}

export class CreateRootFolder {
    public static readonly type = '[Root Folder] create';
    constructor(public newFolder: IFolderDTOOut) {}
}

export class UpdateFolder {
    public static readonly type = '[Folder] update';
    constructor(public folderId: number, public newFolder: IFolderDTOOut) {}
}

export class DeleteFolder {
    public static readonly type = '[Folder] delete';
    constructor(public folderId: number) {}
}

export class CreateFile {
    public static readonly type = '[File] create';
    constructor(public parentFolderId: number, public newFile: IFileDTOOut) {}
}

export class UpdateFile {
    public static readonly type = '[File] update';
    constructor(public folderId: number, public fileId: number, public file: IFileDTOOut, public isSearch?: boolean) {}
}

export class DeleteFile {
    public static readonly type = '[File] delete';
    constructor(public parentFolderId: number, public fileId: number, public isSearch?: boolean) {}
}

export class SearchFiles {
    public static readonly type = '[File] search';
    constructor(public searchValue: string) {}
}

export class GoBackToParentFolder {
    public static readonly type = '[Parent folder] go back';
}

export class NavigateToParent {
    public static readonly type = '[Parent] navigate';
    constructor(public parentFolderId?: number) {}
}

export class ResetCloudData {
    public static readonly type = '[Reset] cloud data';
}
